












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import StringUtils from '@/helpers/stringUtils';
import moment from 'moment';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class VisitsVisitorsDailyCharts extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop({ default: false })
  quantity: boolean;

  @Prop()
  configs: any;

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions = {};

  buldChartOptions() {
    this.chartOptions = {
      legend: {
        position: 'bottom'
      },
      height: 250,
      chartArea: { left: '60', top: '20', right: '20', bottom: '100' },
      fontSize: 12,
      hAxis: {
        slantedText: true,
        slantedTextAngle: 45
      },
      vAxis: {
        title: this.quantity ? 'Quantidade' : 'Horas',
        minValue: 0,
        titleTextStyle: {
          italic: false
        }
      },
      series: {
        [this.getGoalPosition()]: {
          color: '#00AA00',
          lineDashStyle: [12, 6],
          lineWidth: 2,
          pointSize: 0
        }
      }
    };
  }

  mounted() {
    this.buldChartOptions();
    this.load();
  }

  load() {
    this.chartData = [];
    let map = new Map();
    let dates = new Set<string>();
    let names = new Set<string>();
    this.kpis.forEach((i) => {
      if (!map[i.data]) {
        map[i.data] = [];
      }
      if (!map[i.data][i.nome]) {
        map[i.data][i.nome] = [];
      }
      map[i.data][i.nome] = this.quantity ? i.quantidadeTotal : Math.ceil((i.tempoTotalMinutos / 60) * 10) / 10;
      dates.add(i.data);
      names.add(i.nome);
    });

    let headers = ['Data'];
    names.forEach((n) => headers.push(StringUtils.abbreviate(n, 20)));
    headers.push('Meta');
    this.chartData.push(headers);
    dates.forEach((d) => {
      let day = [];
      day.push(moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY'));
      names.forEach((n) => {
        let v = map[d][n];
        if (!v) {
          v = 0;
        }
        day.push(v);
      });
      day.push(this.getGoalValue());
      this.chartData.push(day);
    });
  }

  @Watch('kpis', { immediate: true })
  @Watch('configs', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }

  getGoalPosition() {
    let names = new Set<string>();
    this.kpis.forEach((i) => {
      names.add(i.nome);
    });
    return names.size;
  }

  getGoalValue() {
    if (!this.configs) {
      return null;
    }
    if (this.quantity) {
      return this.configs.qtdeMetaDiaria;
    }
    return this.configs.tempoMetaDiariaHoras;
  }
}
